import { Button, Form, Col, Offcanvas } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import WebService from "../../../utility/WebService";
import { Label } from "../../../components/Label/Label";
import HelperService from "../../../utility/HelperService";

interface PropData {
    isShow: boolean;
    isClose: Function;
    data: any;
}

interface formInterface {
    id: string;
    uuid: string;
    name: string;
    comment: string;
}

const AddBankAccount = (props: PropData) => {
    const { handleSubmit, formState: { errors }, control, watch, getValues, register, reset, setValue } = useForm<formInterface>({});
    const watchAllFields = watch();
    const [isEdit, setIsEdit] = useState<boolean>(false);

    useEffect(() => {
        if (props.isShow) {
            if (props.data && !HelperService.isEmptyObject(props.data)) {
                reset(props.data);
                setIsEdit(true);
            } else {
                reset({});
                resetForm();
                setIsEdit(false);
            }
        }
    }, [props.isShow, props.data]);

    const handleFormSubmit = (data: formInterface) => {
        const url = isEdit ? `payment_mode/update` : "payment_mode/create";
        WebService[isEdit ? "putAPI" : 'postAPI']({
            action: url, body: data, id: "changePassword-btn",
        })
            .then((res: any) => {
                toast.success(res.message);
                closeModal(true);
            })
            .catch(() => { });
    };

    const closeModal = (e: boolean) => {
        reset();
        resetForm();
        props.isClose(e);
    };

    const resetForm = () => {
        setValue('name', '');
        setValue('comment', '');
    };

    return (
        <>
            <Offcanvas show={props.isShow} onHide={props.isClose} placement="end">
                <Offcanvas.Header closeButton><Offcanvas.Title>{isEdit ? "Edit Account" : "Add Account"}</Offcanvas.Title></Offcanvas.Header>
                <Offcanvas.Body className="form-style">
                    <form className="form-style" onSubmit={handleSubmit(handleFormSubmit)}  >
                        <Col lg={12} className="mb-3">
                            {/* First Name */}
                            <Controller
                                control={control}
                                name="name"
                                rules={{ required: "Please Enter Name" }}
                                render={({ field: { onChange, onBlur }, fieldState: { isTouched } }) => (
                                    <div className="mb-2">
                                        <Form.Label>Name</Form.Label>
                                        <span className="text-danger">*</span>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Name"
                                            onChange={onChange}
                                            onBlur={onBlur}
                                            value={watchAllFields.name}
                                        />
                                        {(errors["name"]?.message || Boolean(errors["name"]?.message) || (isTouched && !watchAllFields.name)) && (
                                            <div className="login-error">
                                                <Label title={errors.name?.message || "Please Enter Name."} modeError={true} />
                                            </div>
                                        )}
                                    </div>
                                )}
                            />

                            {/* Comment */}
                            <Controller
                                control={control}
                                name="comment"
                                // rules={{ required: "Please Enter Comment" }}
                                render={({ field: { onChange, onBlur }, fieldState: { isTouched } }) => (
                                    <div className="mb-2">
                                        <Form.Label>Comment</Form.Label>
                                        <textarea
                                            className="form-control"
                                            placeholder="Comment"
                                            onChange={onChange}
                                            onBlur={onBlur}
                                            value={watchAllFields.comment}
                                        />
                                        {(errors["comment"]?.message || Boolean(errors["comment"]?.message) || (isTouched && !watchAllFields.comment)) && (
                                            <div className="login-error">
                                                <Label title={errors.comment?.message || "Please Enter Comment."} modeError={true} />
                                            </div>
                                        )}
                                    </div>
                                )}
                            />
                        </Col>


                        <div className="text-center">
                            <Button
                                variant="dark"
                                className="btn-brand-1 px-5 mt-3 mb-3 me-2"
                                type="submit"
                                id="changePassword-btn"
                            >
                                {isEdit ? "Update" : "Add"}
                            </Button>
                            <Button
                                variant="light"
                                className="btn-brand-1 px-5 mt-3 mb-3"
                                type="button"
                                onClick={() => closeModal(false)}
                            >
                                Close
                            </Button>
                        </div>
                    </form>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default AddBankAccount;
